import { ERouteNames, ERoutePaths } from '@/types';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

export default function RedirectHandler() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const type = searchParams.get('type');
    const question = searchParams.get('question');

    let basePath = `/${ERoutePaths.MATCH_SPECIALIST}/`;
    if (type === ERouteNames.MENTAL_HEALTH_EXPERT) {
      basePath = `/${ERoutePaths.MATCH_THERAPIST}/`;
    }

    const params = new URLSearchParams();
    if (question) {
      params.set('question', question);
    }

    const url = params.toString()
      ? `${basePath}${ERoutePaths.QUESTIONS}?${params.toString()}`
      : basePath;

    navigate(url, { replace: true });
  }, [navigate, searchParams]);

  return null;
}
